import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledContainer = styled(Ds.Flex)`
    text-align: center;
    height: 100%;
    padding: 0 0.75rem;
`;
